import arrowIosForwardFill from '@iconify/icons-eva/arrow-ios-forward-fill';
import { Icon } from '@iconify/react';
import { formatDistance } from 'date-fns';
import faker from 'faker';
import { Link as RouterLink } from 'react-router-dom';
// material
import {
  Avatar,
  Box,
  Button,
  Card,
  CardHeader,
  Divider,
  Link,
  Stack,
  Typography
} from '@mui/material';
// utils
import { mockImgCover } from '../../../utils/mockImages';
//
import Scrollbar from '../../Scrollbar';

// ----------------------------------------------------------------------

const NEWS = [...Array(5)].map((_, index) => {
  const setIndex = index + 1;
  return {
    title: faker.name.title(),
    description: faker.lorem.paragraphs(),
    image: mockImgCover(setIndex),
    postedAt: faker.date.soon()
  };
});

function NewsItem({ order }) {
  return (
    <Stack direction="row" alignItems="center" spacing={2}>
      {/* <Box
        component="img"
        alt={title}
        src={image}
        sx={{ width: 48, height: 48, borderRadius: 1.5 }}
      /> */}
      <Avatar sx={{ bgcolor: 'primary.main' }}>{order.customer.name}</Avatar>
      <Box sx={{ minWidth: 240, flexGrow: 1 }}>
        <Link to="#" color="inherit" underline="hover" component={RouterLink}>
          <Typography variant="subtitle2" noWrap>
            {`${order.total_price}€`}
          </Typography>
        </Link>
        <Typography variant="body2" sx={{ color: 'text.secondary' }} noWrap>
          {JSON.parse(order.data).map((item) => `${item.amount}x ${item.product.name}, `)}
        </Typography>
      </Box>
      <Typography variant="caption" sx={{ pr: 3, flexShrink: 0, color: 'text.secondary' }}>
        {formatDistance(new Date(order.created_at), new Date())}
      </Typography>
    </Stack>
  );
}

export default function AppNewsUpdate({ title, list }) {
  return (
    <Card>
      <CardHeader title={title} />

      <Scrollbar>
        <Stack spacing={3} sx={{ p: 3, pr: 0 }}>
          {list.slice(0, 5).map((order) => (
            <NewsItem key={order.id} order={order} />
          ))}
        </Stack>
      </Scrollbar>

      <Divider />

      <Box sx={{ p: 2, textAlign: 'right' }}>
        <Button
          to="#"
          size="small"
          color="inherit"
          component={RouterLink}
          endIcon={<Icon icon={arrowIosForwardFill} />}
        >
          View all
        </Button>
      </Box>
    </Card>
  );
}
